import Dataset from 'scoreboard/datasets/model/dataset'
import blankMessage from './blank-message'

/**
 * If the given value is the BLANK placeholder value, returns a localized
 * and capitalized "Blank" message. Otherwise, returns the given value.
 */
function translateBlank (value) {
	return value === Dataset.BLANK
		? blankMessage()
		: value
}

export default translateBlank

translateBlank.__filename__ = 'charts/translate-blank.js'
